import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
   login,
   logout,
   resendOtp,
   verifyOtp,
   setFetchState,
} from "../actions/user";
import Login from "../components/Login";

const mapStateToProps = (state) => {
   const { login } = state;
   const { isFetching, message, isNotifyMessage, data } = login || {
      isFetching: true,
      message: "",
      isNotifyMessage: false,
   };
   return { isFetching, message, isNotifyMessage, data };
};

const mapDispatchToProps = (dispatch) =>
   bindActionCreators(
      {
         login,
         logout,
         verifyOtp,
         resendOtp,
         setFetchState,
      },
      dispatch
   );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
